import { keys, values } from '../../utils/javascript'

const countryData = {
  in: {
    Gujarat: {
      Surat: [394006, 394105, 394500, 394510],
      Ahmadabad: [363610, 380001, 382150, 382230],
    },
  },
}

const countryLabels = {
  in: 'India',
}

const countryOptions = keys(countryData).map(key => ({
  value: key,
  label: countryLabels[key],
}))

const stateOptions = values(countryData)
  .map(value => keys(value).map(state => ({ value: state, label: state })))
  .flat()

const cityOptions = values(countryData)
  .map(countryObj =>
    values(countryObj).map(stateObj =>
      keys(stateObj).map(city => ({ value: city, label: city })),
    ),
  )
  .flat(2)

const pincodeOptions = values(countryData)
  .map(countryObj =>
    values(countryObj).map(stateObj =>
      values(stateObj).map(pinArr =>
        pinArr?.map(pin => ({ value: pin, label: pin })),
      ),
    ),
  )
  .flat(3)

export {
  countryData,
  cityOptions,
  countryOptions,
  pincodeOptions,
  stateOptions,
  countryLabels,
}
